import ClinicConstantsWomenLocal from '@/utils/clinic-constants.women.local'
import ClinicConstantsMenLocal from './clinic-constants.men.local'
import ClinicConstantsWomenStg from '@/utils/clinic-constants.women.stg'
import ClinicConstantsMenStg from './clinic-constants.men.stg'
import ClinicConstantsWoMenProd from '@/utils/clinic-constants.women.prod'
import ClinicConstantsMenProd from '@/utils/clinic-constants.men.prod'
import { IsMens } from './app-setting'

export const getClinics = () => {
  if (process.env.VUE_APP_CLINIC_CONST_FILE === 'local' && IsMens()) {
    return ClinicConstantsMenLocal.CLINICS
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'local' && !IsMens()) {
    return ClinicConstantsWomenLocal.CLINICS
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'stg' && IsMens()) {
    return ClinicConstantsMenStg.CLINICS
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'stg' && !IsMens()) {
    return ClinicConstantsWomenStg.CLINICS
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'prod' && IsMens()) {
    return ClinicConstantsMenProd.CLINICS
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'prod' && !IsMens()) {
    return ClinicConstantsWoMenProd.CLINICS
  }
}

export const getOsakaClinicId = () => {
  let osakaClinicId = ''
  if (process.env.VUE_APP_CLINIC_CONST_FILE === 'local') {
    osakaClinicId = ClinicConstantsWomenLocal.OSAKA.clinicId
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'stg') {
    osakaClinicId = ClinicConstantsWomenStg.OSAKA.clinicId
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'prod') {
    osakaClinicId = ClinicConstantsWoMenProd.OSAKA.clinicId
  }
  return osakaClinicId
}

export const getTokyoClinicId = () => {
  let tokyoClinicId = ''
  if (process.env.VUE_APP_CLINIC_CONST_FILE === 'local') {
    tokyoClinicId = ClinicConstantsWomenLocal.TOKYO.clinicId
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'stg') {
    tokyoClinicId = ClinicConstantsWomenStg.TOKYO.clinicId
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'prod') {
    tokyoClinicId = ClinicConstantsWoMenProd.TOKYO.clinicId
  }
  return tokyoClinicId
}

export const getNagoyaClinicId = () => {
  let nagoyaClinicId = ''
  if (process.env.VUE_APP_CLINIC_CONST_FILE === 'local') {
    nagoyaClinicId = ClinicConstantsWomenLocal.NAGOYA.clinicId
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'stg') {
    nagoyaClinicId = ClinicConstantsWomenStg.NAGOYA.clinicId
  } else if (process.env.VUE_APP_CLINIC_CONST_FILE === 'prod') {
    nagoyaClinicId = ClinicConstantsWoMenProd.NAGOYA.clinicId
  }
  return nagoyaClinicId
}

export interface IClinicSetting {
  name: string
  clinicId: string
  clinicalDepartmentId: string
  treatmentCourseId: string
  businessDays: string[],
  nonTargetDays: {
    [x: number]: {
        am: boolean;
        pm: boolean;
    };
  };
}

export interface IClinicConstants {
  /* medicalBusinessId */
  MEDICAL_BUSINESS_ID: string

  /* 各clinic情報 */
  SAPPORO: IClinicSetting
  TOKYO: IClinicSetting
  SINJUKU: IClinicSetting
  NAGOYA: IClinicSetting
  OSAKA: IClinicSetting
  FUKUOKA: IClinicSetting

  /* clinic情報 */
  CLINICS: IClinicSetting[]
}